export Vendors from './Vendors';
export MergeVendors from './MergeVendorsRenderer';



// WEBPACK FOOTER //
// /src/components/Vendors/index.js